import type { CSSProperties } from 'react';

export const cardBodyStyle: CSSProperties = {
  padding: '5px',
  paddingBottom: '10px',
};
